import Popup from './popup';

document.addEventListener('DOMContentLoaded', () => {
  const popup = new Popup();

  const confirmPopup = document.querySelector('.alertConfirm');
  if (confirmPopup) {
    let confirmTrigger = null;
    const approve = confirmPopup.querySelector('.alertApprove');
    if (approve) {
      approve.addEventListener('click', () => {
        popup.close();
        if (confirmTrigger) {
          if (confirmTrigger.getAttribute('data-confirm-event')) {
            const eventData = JSON.parse(confirmTrigger.getAttribute('data-confirm-event'));
            document.body.dispatchEvent(new CustomEvent(eventData.name, {
              detail: eventData.detail,
            }));
          } else if (confirmTrigger.href) {
            window.location.href = confirmTrigger.href;
          }
        }
      });
    }

    document.addEventListener('click', (e) => {
      if (e.target
                && e.target.closest('[data-confirm]')
      ) {
        e.preventDefault();
        confirmTrigger = e.target.closest('[data-confirm]');
        confirmPopup.querySelector('h3').textContent = confirmTrigger.dataset.confirm;
        popup.open('.alertConfirm');
      }
    });
  }

  // prompt
  const prompts = document.querySelectorAll('[data-prompt]');
  const promptPopup = document.querySelector('.alertPrompt');

  if (prompts.length) {
    prompts.forEach((prompt) => {
      prompt.addEventListener('click', (e) => {
        e.preventDefault();

        const url = prompt.href;
        const approve = promptPopup.querySelector('.alertApprove');

        promptPopup.querySelector('h3').textContent = prompt.dataset.prompt;

        popup.open('.alertPrompt');

        approve.addEventListener('click', () => {
          const input = promptPopup.querySelector('input');

          if (input.value.length) {
            window.location.href = url + input.value;
          }

          popup.close();
        });
      });
    });
  }
});
